import TOGGLE_DRAWER from '../class/toggleDrawer';
import SUBNAV from '../class/subnav';
import TOGGLE_PAGETOP from '../class/togglePagetop';
import LAZY_DISP from '../class/lazydisp';
import CURRENT_NAV from '../class/currentNav';

export default class INIT {

  constructor() {
    // メニュードロワー開閉
    new TOGGLE_DRAWER();

    // サブメニュー開閉
    new SUBNAV();

    // ページトップをスクロールで表示する
    new TOGGLE_PAGETOP();

    // lazydisp
    $(() => new LAZY_DISP('[data-lazydisp]'));
  
    // currentクラス付与
    new CURRENT_NAV('.gnav,[data-plugin="currentNav"],[data-plugin="currentMenu"]');
  }

}